import type { SVGProps } from 'react';

export function FacelessAvatar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="50" cy="50" r="50" fill="currentColor" fillOpacity="0.1" />
      <path
        d="M50 55C61.0457 55 70 46.0457 70 35C70 23.9543 61.0457 15 50 15C38.9543 15 30 23.9543 30 35C30 46.0457 38.9543 55 50 55Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M17.071 82.929C25.556 74.444 37.283 69 50 69C62.717 69 74.444 74.444 82.929 82.929C74.444 91.414 62.717 96.858 50 96.858C37.283 96.858 25.556 91.414 17.071 82.929Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </svg>
  );
}
